import router from "@/lib/router";
import breadcrumb from "@/lib/breadcrumb";
import i18n from "@/lib/i18n";

export default {
	install() {
		i18n.mergeLocaleMessage("fr", {
			"breadcrumb.collecting.organizations": "Orgnanismes collecteurs",
			"breadcrumb.collecting.organizations.add": "Créer un organisme collecteur",
			"breadcrumb.collecting.organizations.edit": "Editer un organisme collecteur",
			"menu.collecting.organizations": "Organismes collecteurs"
		});

		breadcrumb.add([
			{
				path: "/database/collectingOrganizations",
				name: "home>database>collecting.organizations"
			},
			{
				path: "/database/collectingOrganizations/create",
				name: "home>database>collecting.organizations>collecting.organizations.add"
			},
			{
				path: "/database/collectingOrganizations/([0-9]+)/edit",
				replacePath: "/database/collectingOrganizations/{1}/edit",
				name: "home>database>collecting.organizations>collecting.organizations.edit"
			}
		]);

		router.addRoutes([
			{
				path: "/database/collectingOrganizations",
				name: "collectingOrganizations",
				component: () => import("./vues/List.vue"),
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/collectingOrganizations/create",
				name: "collectingOrganizations.create",
				component: () => import("./vues/AddEdit.vue"),
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/collectingOrganizations/:id/edit",
				name: "collectingOrganizations.edit",
				component: () => import("./vues/AddEdit.vue"),
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			}
		]);
	}
};
